/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @type {ComposerState}
 */
export const composerState = {
    mode: "display",
    contentOnly: true,
    lastComponentAdded: null,
    snackbarMessage: "",
    activeFieldName: "",
    fieldsState: [],
    guid: null
};

/**
 * @typedef {object} ComposerState
 * @property {'display' | 'edit'} mode
 * @property {boolean} contentOnly
 * @property {string | null} lastComponentAdded
 * @property {string} snackbarMessage
 * @property {string} activeFieldName
 * @property {object[]} fieldsState
 * @property {string} guid
 */
